import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Articulo.types';
import { IArticulo, IPrecio, Oferta, OpcionDePrecio, IEstadisticaVentas } from './Articulo.lib';
import { Cliente } from '@/__env/lib/Clientes';
import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
import { Stock } from '@/__env/lib/Articulos/Stock.lib';
import moment, { Moment } from 'moment';
import { Atributo } from '@/__env/lib/Articulos/Atributos';
import { Contenido } from '@/__env/lib/Articulos/Contenido';
import { Imagen } from '@/__env/lib/Articulos/Imagenes';
import { Titulo } from '@/__env/lib/Articulos/Titulos';
import { Sector } from '@/__env/lib/Articulos/Sectores';
import { Linea } from '@/__env/lib/Articulos/Lineas';
import { Marca } from '@/__env/lib/Articulos/Marcas';
import { AtributosGenerales } from '@/__env/lib/Articulos/AtributosGenerales/AtributosGenerales.nav';
import { Unidad } from '@/__env/lib/Articulos/Unidades';
import { arch, type } from 'os';

export class Articulo extends IArticulo
{

    public static async create( id: string, params: any = null ): Promise<Articulo>
    {
        let o = new Articulo();
        o.Id = id.toString().formatearCodigoArticulo();
        if ( await o.find( params ) )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/articulos';
    protected async find( params: any = null ): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id.toString().formatearCodigoArticulo().eliminar( "/" )}`;
        if ( params )
            request.params = params;

        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async Comprobar( c: string ): Promise<boolean>
    {

        let request = new apiRequest();
        request.path = `/comprobar/articulo`;
        request.params.id = c;
        if ( await request.post() )
        {
            return true;
        }
        return false;
    }



    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Articulo>; Error?: boolean; }>
    {

        let a: Array<Articulo> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/arti2culos` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Articulo( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id.eliminar( '/' )}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            else
            {
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            return true;
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id.eliminar( '/' )}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }



    public async cargarPrecio( tipo: string, cantidad?: number, cliente?: number, subtipo?: string, id_publicacion?: string ): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `/articulos/precio/${this.Id.eliminar( '/' )}`;

                req.params.tipo = tipo;
                if ( subtipo ) req.params.subtipo = subtipo;
                if ( id_publicacion ) req.params.id_publicacion = id_publicacion;
                if ( cliente ) req.params.cliente = cliente;
                if ( cantidad ) req.params.cantidad = cantidad;

                if ( await req.get() )
                {
                    this.Precio = new Precio( req.data );
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async cargarPrecios( tipo?: string, subtipo?: string, cliente?: number ): Promise<{ Paginacion: Paginacion, Items: Array<OpcionDePrecio>; Error?: boolean; }>
    {

        let a: Array<OpcionDePrecio> = [];
        let paginacion: Paginacion = new Paginacion();
        let req = new apiRequest();
        req.path = `/articulos/${this.Id.eliminar( '/' )}/precios`;

        if ( tipo ) req.params.tipo = tipo;
        if ( subtipo ) req.params.subtipo = subtipo;
        if ( cliente ) req.params.cliente = cliente;

        if ( await req.get() )
        {
            if ( req.data.response )
            {
                paginacion = new Paginacion( req.data.response );
            }
            if ( req.data.results )
            {
                for ( let i of req.data.results )
                {
                    let p = new OpcionDePrecio( this, i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: req.error };
    }


    public async cargarOfertas( tipo?: string, subtipo?: string, cliente?: number ): Promise<{ Paginacion: Paginacion, Items: Array<Oferta>; Error?: boolean; }>
    {

        let a: Array<Oferta> = [];
        let paginacion: Paginacion = new Paginacion();
        let req = new apiRequest();
        req.path = `/articulos/${this.Id.eliminar( '/' )}/ofertas`;

        if ( tipo ) req.params.tipo = tipo;
        if ( subtipo ) req.params.subtipo = subtipo;
        if ( cliente ) req.params.cliente = cliente;

        if ( await req.get() )
        {
            if ( req.data.response )
            {
                paginacion = new Paginacion( req.data.response );
            }
            if ( req.data.results )
            {
                for ( let i of req.data.results )
                {
                    let p = new Oferta( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: req.error };
    }

    public async cargarStock(): Promise<boolean>
    {

        try
        {
            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `/stock/${this.Id.eliminar( '/' )}`;
                if ( await req.get() )
                {
                    this.Ubicaciones = req.data.map( ( x: any ) => { return new Stock( x ); } );
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public static async Aleatorios( cantidad: number = 5 ): Promise<string[]>
    {
        try
        {
            let req = new apiRequest();
            req.path = `/articulos/random`;
            req.params.cantidad = cantidad;
            if ( await req.get() )
            {
                return req.data;

            }
        } catch ( e )
        {
            Log( e );
        }
        return [];
    }

    public async CargarTitulo(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                this.Titulo = await Titulo.create( this.TituloId );
                if ( !this.Titulo )
                {
                    this.Titulo = new Titulo();
                    return false;
                } else
                {
                    return true;
                }

            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async CargarUnidad(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                this.Unidad = await Unidad.create( parseInt( this.UnidadId ) );
                if ( !this.Titulo )
                {
                    this.Unidad = new Unidad();
                    return false;
                } else
                {
                    return true;
                }

            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async CargarMarca(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                this.Marca = await Marca.create( this.MarcaId );
                if ( !this.Marca )
                {
                    this.Marca = new Marca();
                    return false;
                } else
                {
                    return true;
                }

            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async CargarClase(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                this.Linea = await Linea.create( this.LineaId );
                if ( !this.Linea )
                {
                    this.Linea = new Linea();
                    return false;
                } else
                {
                    return true;
                }

            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async CargarSector(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                this.Sector = await Sector.create( this.SectorId );
                if ( !this.Titulo )
                {
                    this.Sector = new Sector();
                    return false;
                } else
                {
                    return true;
                }

            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async CargarAtributos(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                this.Atributos = ( await Atributo.find( { articulo: this.Id.eliminar( '/' ) } ) ).Items;
                this.AtributosGenerales = await AtributosGenerales.create( this.Id );
                if ( !this.AtributosGenerales )
                {
                    this.AtributosGenerales = new AtributosGenerales();
                    this.AtributosGenerales.Articulo = this.Id;
                }
                return true;
            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }



    public async CargarOfertas(): Promise<boolean>
    {

        try
        {
            if ( this.Existe )
            {
                let request = new apiRequest( `/articulos/${this.Id.eliminar( '/' )}/ofertas` );

                if ( await request.get() )
                {
                    this.Ofertas = request.data.results.map( ( x: any ) => { return new Oferta( x ); } );
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async CargarDescripcion()
    {
        try
        {
            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id.eliminar( '/' )}/descripciones`;
                if ( await req.get() )
                {
                    return {
                        Descripcion: String( req.data.descripcion ),
                        Fecha: req.data.updated_at ? moment( req.data.updated_at ) : moment( req.data.created_at ),
                    };
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;

    }

    public async GuardarDescripcion( descripcion: string ): Promise<boolean>
    {

        try
        {
            if ( this.Existe )
            {
                let request = new apiRequest( `/articulos/${this.Id.eliminar( '/' )}/descripciones` );
                request.body = { descripcion: descripcion };
                if ( await request.post() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async CargarObservacion(): Promise<{ Observacion: string, Fecha: Moment; }>
    {

        try
        {
            if ( this.Existe )
            {
                let request = new apiRequest( `/articulos/${this.Id.eliminar( '/' )}/observaciones` );
                if ( await request.get() )
                {
                    return { Observacion: request.data.observacion, Fecha: moment( request.data.updated_at ) };
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async GuardarObservacion( observacion: string ): Promise<boolean>
    {

        try
        {
            if ( this.Existe )
            {
                let request = new apiRequest( `/articulos/${this.Id.eliminar( '/' )}/observaciones` );
                request.body = { observacion: observacion };
                if ( await request.post() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async AgregarAtributo( Nombre: string, Valor: string, NoCorresponde: boolean = false ): Promise<Atributo>
    {
        try
        {
            let request = new apiRequest( `/articulos/${this.Id.eliminar( '/' )}/atributos` );
            request.body = {};
            request.body.atributo = Nombre.replace( /\s+/g, '_' ).toLowerCase()
                .replace( 'á', 'a' )
                .replace( 'é', 'e' )
                .replace( 'í', 'i' )
                .replace( 'ó', 'o' )
                .replace( 'ú', 'u' )
                .normalize( "NFD" ).replace( /[\u0300-\u036f]/g, "" );
            request.body.descripcion = Nombre;
            request.body.valor = NoCorresponde ? '' : Valor;
            request.body.no_corresponde = NoCorresponde ? 'S' : 'N';

            if ( await request.post() )
            {
                this.Atributos.push( await Atributo.create( request.data.id ) );
                return new Atributo( request.data );
            }

        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async CargarAtributoTitulo(): Promise<Atributo[]>
    {
        try
        {

            let request = new apiRequest( `/articulos/titulos/${this.TituloId}/atributos` );
            if ( await request.get() )
            {
                let atrb: Atributo[] = [];
                for ( let d of request.data )
                {
                    if ( this.Atributos.findIndex( x => x.Atributo == d.atributo ) == -1 )
                    {
                        let a = new Atributo();
                        a.PermiteNoCorresponde = true;
                        a.PorTitulo = true;
                        a.Atributo = d.atributo;
                        a.Descripcion = d.descripcion;
                        atrb.push( a );
                    }


                }
                return atrb;
            }

        } catch ( e )
        {
            Log( e );
        }
        return [];
    }



    public async CargarImagenes(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                this.Imagenes = ( await Imagen.find( { articulo: this.Id.eliminar( '/' ) } ) ).Items;
                return true;
            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }

    public async SubirImagen( archivo: File ): Promise<string>
    {
        try
        {
            let request = new apiRequest( `/articulos/${this.Id.eliminar( '/' )}/imagenes` );
            request.useformData = true;
            request.formData.append( 'file', archivo, {
                filename: archivo.name,
                contentType: 'application/octet-stream',

            } );
            if ( await request.post() )
            {
                this.Imagenes.push( await Imagen.create( request.data.id ) );
                return request.data.id;
            }

        } catch ( e )
        {
            Log( e );
        }
        return '';
    }

    public static async SubirImagen( codigo: string, archivo: File ): Promise<string>
    {
        try
        {
            let request = new apiRequest( `/articulos/${codigo.eliminar( '/' )}/imagenes` );
            request.useformData = true;
            request.formData.append( 'file', archivo );
            if ( await request.post() )
            {
                return request.data.id;
            }

        } catch ( e )
        {
            Log( e );
        }
        return '';
    }

    public async SubirContenido( archivo: File, tipo: string = 'no-especificado' ): Promise<string>
    {
        try
        {
            let request = new apiRequest( `/articulos/${this.Id.eliminar( '/' )}/contenidos` );
            request.useformData = true;
            request.params.tipo = tipo;
            request.formData.append( 'file', archivo );
            if ( await request.post() )
            {
                this.Contenidos.push( await Contenido.create( request.data.id ) );
                return request.data.id;
            }

        } catch ( e )
        {
            Log( e );
        }
        return '';
    }

    public async CargarContenido(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                this.Contenidos = ( await Contenido.find( { articulo: this.Id.eliminar( '/' ) } ) ).Items;
                return true;
            }
        } catch ( e )
        {
            Log( e );
        }
        return null;
    }
}


export class Precio extends IPrecio
{

    public static async create( articulo: string | Articulo, cliente: number | Cliente, cantidad: number ): Promise<Precio>;
    public static async create( articulo: string | Articulo, tipo: Pedidos.Tipos, cantidad: number ): Promise<Precio>;
    public static async create( articulo: string | Articulo, y: number | Cliente | Pedidos.Tipos, cantidad: number ): Promise<Precio>
    {
        //let o = new Precio( articulo, y );
        //o.Cantidad = cantidad;
        //if ( await o.find() )
        //{
        //    return o;
        //}
        return null;
    }

    protected Route: string = '/articulos/precio';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Articulo.eliminar( "/" )}`;

        request.params.tipo = this.Tipo;
        request.params.subtipo = this.SubTipo;
        request.params.id_publicacion = this.IdPublicacion;
        request.params.cliente = this.Cliente;
        request.params.cantidad = this.Cantidad;

        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public async Recargar( json?: any ): Promise<boolean>
    {
        if ( json )
        {
            this.Json = json;
            this.set();
        } else
        {
            return await this.find();
        }

    }

}

export class EstadisticaVentas extends IEstadisticaVentas
{

    public static async create( id: Articulo, mes: number, ano: number ): Promise<EstadisticaVentas>
    {
        let o = new EstadisticaVentas();
        o.Articulo = id;
        o.Mes = mes;
        o.Ano = ano;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }

    public static async actual( articulo: Articulo ): Promise<EstadisticaVentas>
    {
        let o = new EstadisticaVentas();
        if ( moment().getDay() < 7 )
        {
            o.Mes = moment().add( -1, 'month' ).getMonth();
            o.Ano = moment().add( -1, 'month' ).getYear();
        }
        else
        {
            o.Mes = moment().getMonth();
            o.Ano = moment().getYear();
        }

        o.Articulo = articulo;

        if ( await o.find() )
        {
            return o;
        }
        return null;
    }

    protected Route: string = '/estadisticas/ventas/articulo';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.params.articulo = this.Articulo.Id;
        request.params.mes = this.Mes;
        request.params.ano = this.Ano;
        request.path = `${this.Route}`;
        if ( await request.get() )
        {
            this.Json = request.data.ventas[0];
            this.set();
        }
        return this.Existe;
    }


    public static async find( params: any ): Promise<EstadisticaVentas[]>
    {

        let request = new apiRequest();

        if ( params )
            request.params = params;

        request.path = `/estadisticas/ventas/articulo`;
        if ( await request.get() )
        {
            return request.data.ventas.map( ( x: any ) => new EstadisticaVentas( x ) );

        }
        return [];
    }

    public static async actuales( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<EstadisticaVentas>; Error?: boolean; }>
    {

        let a: Array<EstadisticaVentas> = [];
        let paginacion: Paginacion = new Paginacion();


        let request = new apiRequest();
        request.path = `/estadisticas/ventas/articulos`;
        if ( params )
            request.params = params;
        if ( moment().getDay() < 7 )
        {
            request.params.mes = moment().add( -1, 'month' ).getMonth();
            request.params.ano = moment().add( -1, 'month' ).getYear();
        }
        else
        {
            request.params.mes = moment().getMonth();
            request.params.ano = moment().getYear();
        }

        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new EstadisticaVentas( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }



}